<mat-toolbar role="header" class="mat-typography" [ngClass.gt-sm]="{ desktop: true }">
  <mat-toolbar-row>
    <div class="logo-container">
      <mat-icon (click)="onToggleMenu()" style="cursor: pointer">menu</mat-icon>
      <img [src]="logoSrc" class="logo" fxHide fxShow.gt-sm>
    </div>
    <app-cart-summary *ngIf="showCart" class="fill-remaining-space" [class.desktop]="mediaService.desktop$ | async"></app-cart-summary>
  </mat-toolbar-row>

  <mat-toolbar-row class="numbers" *ngIf="menuService.showTableHelper$ | async" [@fadeInOut] fxShow.gt-sm fxHide>
    <!-- make spacers matching the columns in the tables -->
    <div class="spacer big">{{ 'PACK_LIST.TABLE_HEADER_PACKAGE_ID' | translate }}</div>
    <div class="spacer big">{{ 'PACK_LIST.TABLE_HEADER_WAREHOUSE' | translate }}</div>
    <div class="spacer big">{{ 'PACK_LIST.TABLE_HEADER_CERT' | translate }}</div>
    <div class="spacer big">{{ 'PACK_LIST.TABLE_HEADER_LANDED' | translate }}</div>
    <div class="spacer big">{{ 'PACK_LIST.TABLE_HEADER_SHIPPINGMARK' | translate }}</div>
    <div class="spacer small">{{ 'PACK_LIST.TABLE_HEADER_VOLUME' | translate }}</div>
    <div class="spacer small">{{ 'PACK_LIST.TABLE_HEADER_WEIGHT' | translate }}</div>
    <div class="spacer small">{{ 'PACK_LIST.TABLE_HEADER_TOTAL_NUM_PIECES' | translate }}</div>
    <ng-container *ngFor="let length of packetLengths">
      <small>{{ length }}</small>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar>
